import { z } from 'zod';

type LoginSchemaMessage = {
  LengthMessage: (length: number) => string;
  RequiredMessage: string;
  NoFullWidthMessage: string;
};

export const LoginSchema = (messages: LoginSchemaMessage) =>
  z.object({
    userId: z
      .string()
      .min(1, messages.RequiredMessage)
      .max(100, messages.LengthMessage(100))
      .regex(
        /^[^\uFF01-\uFF5E\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]*$/,
        messages.NoFullWidthMessage
      ),
    password: z
      .string()
      .min(1, messages.RequiredMessage)
      .max(100, messages.LengthMessage(100))
      .regex(
        /^[^\uFF01-\uFF5E\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]*$/,
        messages.NoFullWidthMessage
      ),
  });
export type LoginSchemaType = z.infer<ReturnType<typeof LoginSchema>>;

type ConfirmMfaSchemaMessages = {
  LengthMessage: (length: number) => string;
  NumericMessage: string;
  RequiredMessage: string;
};
export const ConfirmMfaSchema = (messages: ConfirmMfaSchemaMessages) =>
  z.object({
    mfaCode: z
      .string()
      .min(1, messages.RequiredMessage)
      .length(6, messages.LengthMessage(6))
      .regex(/^[0-9]+$/, messages.NumericMessage),
  });
export type ConfirmMfaSchemaType = z.infer<ReturnType<typeof ConfirmMfaSchema>>;
